import { API_BASE, apiFetch } from "../../api/http";

export async function postFlawAnalysis(body: { prompt?: string; jurisdiction?: string; docContent?: string; requirement?: string; clientName?: string; projectNumber?: string; documentType?: string; }): Promise<{ analysis: string }>{
  const res = await apiFetch(`${API_BASE}/api/flawAnalysis`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error(`flawAnalysis failed: ${res.status}`);
  return res.json();
}


